import axios from '@axios'

export default {
  buscar(filtro, cancelToken) {
    return axios.post('/busca-global', filtro, { cancelToken })
  },
}
